/*    
<summary>
  This functional component "Settings" provides form to select language.
  Developer:Aashish Singh, Created Date:28-Aug-2022
</summary>
<returns>Returns JSX</returns>
*/

import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import "../components/user-profile.css";
import { useStore } from "../../../contexts/store-provider";
import LoaderButton from "../../../shared-components/button/loader-button";
import Englishflag from "../../../assets/Images/svg/united-kingdom.svg"
import Japanflag from "../../../assets/Images/svg/japan.svg"
import { formatMessage } from "../../../translations/format-message";
import authStore from "../../../core/stores/auth-store";
import userTypeEnum from "../../../constants/enums/user-type-enum";

interface IProps {
  modalClosed: () => void;
}

const Settings = (props: IProps) => {
  const { preferencesStore } = useStore();
  const [lang, setLang] = useState<string>(preferencesStore.getLanguage);
  const { getUserType, getEmail, userType } = authStore;
  const { getTenantAccess, setTenantAccess } = preferencesStore;
  const submitHandler = () => {
    props.modalClosed();
    preferencesStore.changeLanguage(lang);
  };
  return (
    <div className="pt-3 mt-3">
    <div className="form-group row justify-content-around">
       {/* <div className={"col-12 lang text-center form-title"}>
         <FormattedMessage id="language" />
       </div> */}
       <div className={"col-md-4 col-sm-6 col-12 language"}>
         <input
           data-testid="testEnLanguage"
           className="form-check-input"
           type="radio"
           name="language"
           id="language1"
           checked={lang === "en" && true}
           value="en"
           onChange={() => setLang("en")}
         />
         <label className="form-check-label" htmlFor="language1">
         <svg height="80" width="80" version="1.1" x="0px" y="0px" viewBox="0 0 256 256" enable-background="new 0 0 256 256"><g><g><path d="M127.4,156.1c-0.1-4.9-4.1-8.8-9-8.8H45.8c-2.9,0-5.3-2.3-5.3-5.3V93.9h77.9c5,0,9-4,9-9s-4-9-9-9H40.5V33.2c0-2.9,2.3-5.2,5.3-5.2h72.6c4.9,0,8.9-3.9,9-8.8c0.1-5-4.1-9.2-9.2-9.2H37.2c-8,0-14.5,6.5-14.5,14.5v126.1c0,8,6.5,14.5,14.5,14.5h81.1C123.3,165.3,127.5,161.1,127.4,156.1z M188,64.2c-10.3,0-19.7,3.4-27.4,9.2v-2.7c0-5-4-9-9-9c-5,0-9,4-9,9v87.8c0,5,4,9,9,9c5,0,9-4,9-9v-49c0-15.1,12.3-27.4,27.4-27.4c15.1,0,27.4,12.3,27.4,27.4v49c0,5,4,9,9,9c5,0,9-4,9-9v-49C233.4,84.5,213,64.2,188,64.2z M178.1,218.1c0,0-5.9,5.7-14.4,8.5c-10.9,3.6-20.7,0.8-29.9-8.4c-7.7-7.7-16.2-12.5-25.4-14.3c-7.4-1.5-15.1-0.9-22.8,1.6c-12.4,4-20.5,11.8-21.4,12.7c-3.5,3.5-3.6,9.2-0.1,12.7c3.5,3.5,9.2,3.6,12.7,0.1c0,0,5.9-5.7,14.4-8.5c10.9-3.6,20.7-0.8,29.9,8.4c7.7,7.7,16.2,12.5,25.4,14.3c2.7,0.5,5.5,0.8,8.3,0.8c4.8,0,9.7-0.8,14.5-2.4c12.4-4,20.5-11.8,21.4-12.7c3.5-3.5,3.6-9.2,0.1-12.7C187.3,214.7,181.7,214.6,178.1,218.1z"></path></g></g></svg>
      
           English
         </label>
       </div>
       <div className={"col-md-4 col-sm-6 col-12 language"}>
         <input
           data-testid="testJpLanguage"
           className="form-check-input "
           type="radio"
           name="language"
           id="language2"
           value="jp"
           checked={lang === "jp" && true}
           onChange={() => setLang("jp")}
         />
         <label className="form-check-label" htmlFor="language2">
          <svg height="80" width="80" version="1.1" x="0px" y="0px" viewBox="0 0 256 256" enable-background="new 0 0 256 256"><g><g><path d="M103.2,112.1c4.1-1.9,8.2-3.6,12.3-5.2c6.4-2.4,13-4.6,19.7-5.9c1.1-0.2,1.6-0.6,1.5-1.9c-0.1-3.6-0.2-7.2-0.6-10.8c-0.3-3.2,0.5-4.2,3.7-3.8c3.4,0.4,6.7,1.5,9.2,3.9c2.9,2.7,3.1,6.3,2.5,9.9c-0.1,0.9-0.1,1.2,0.8,1.2c4.8-0.1,9.6,0.2,14.4,0.6c10.2,0.9,20.3,2.6,29.5,7.3c8.4,4.4,15.9,9.9,21.2,18c4.1,6.2,6.4,13.1,7.4,20.5c0.5,3.4,0.6,6.9,0.6,10.4c-0.2,9.7-2.2,18.9-6.1,27.7c-4.8,11.1-11.4,21-20.4,29.2c-7.6,7-16.2,12.6-25.4,17.4c-10.3,5.4-20.9,9.6-32.3,12.1c-5.8,1.3-11.7,2.4-17.7,3.1c-1.2,0.1-2.4,0.3-3.7,0.2c-0.5,0-1-0.1-1.2-0.5c-0.2-0.5,0.4-0.8,0.7-1c2.1-1.3,4.4-2.2,6.7-3.1c6.8-2.7,13.9-4.7,20.6-7.6c11.1-4.8,21.4-10.9,31.1-18c9.1-6.7,16.8-14.7,22.6-24.5c4.7-7.8,7.9-16.2,9.1-25.3c1.3-10.4,0.6-20.4-3.8-30c-6-13-16.3-20.9-30.2-24.3c-8.1-2-16.4-2.3-24.7-2.2c-1.1,0-1.1,0.7-1.3,1.3c-2.4,8.4-5.2,16.5-8.5,24.6c-4.6,11.3-10.5,21.9-16.9,32.2c-4,6.4-8.2,12.7-12.5,18.9c-0.6,0.8-0.6,1.4-0.2,2.2c3.2,6.6,6.4,13,11.4,18.4c1.2,1.3,2.2,2.9,2.4,4.8c0.4,3.3-1.4,6-5,7.2c-5.7,1.9-7.9,1.6-12.5-4.6c-3.2-4.4-5.4-9.3-7.6-14.2c-0.6-1.3-0.9-1.1-1.8-0.3c-7.3,7.1-15,13.9-23.9,19.1c-4.9,2.8-10,5.1-15.7,6.1c-3.6,0.6-7.2,0.7-10.8,0c-4.2-0.7-7.3-3.3-9.9-6.5c-3.4-4.3-6.3-9-7.3-14.5c-0.7-4-0.7-8-0.1-12c1.2-7.6,3.5-15,6.9-21.9c4-8.1,9.7-15,15.9-21.5c10.9-11.4,23.1-21.1,35.9-30.3c0.9-0.6,1.2-1.3,1.3-2.4c0.2-6.7,0.7-13.4,1-20.2c0.1-4,0.4-7.9,0.6-11.9c0.2-3,0.1-6,0.5-9c0.3-2.4,0-2.5-2.4-2.1c-3.7,0.5-7.4,0.6-11.1,0.8c-4.4,0.2-8.8,0.3-13.2,0c-7.4-0.4-14.8-1.6-21.8-4.3c-1.6-0.6-3.1-1.5-4.3-2.9c-1.1-1.4-0.8-2.4,0.8-3c1.9-0.6,3.8-0.7,5.7-0.5c5.5,0.5,10.9,0.3,16.4,0.2c7.4,0,14.7-0.7,22-1.8c2.6-0.4,5.1-0.7,7.7-1c0.9-0.1,1.3-0.3,1.5-1.4c0.7-6.4,1.2-12.7,1.5-19.1c0.3-5.7,0.5-11.3-0.7-16.9c-0.5-2.3-1.6-4.4-2-6.7c-0.2-1.1-0.2-2.2-0.1-3.3c0.2-1.8,1.8-3.1,3.7-3.2c3.6-0.2,6.8,1.1,9.9,2.5c2.6,1.2,5,2.9,7.3,4.7c2.6,2.2,3.2,4.9,1.9,8.6c-0.9,2.5-2.1,4.8-3.8,6.7c-1.8,2-2.2,4.3-2.4,6.8c-0.5,5.6-1.2,11.1-1.8,16.6c-0.1,0.8,0,1,1,0.8c14.4-3.7,28.6-7.6,42.2-13.7c4.8-2.2,9.8-3.6,15.1-3.3c3.3,0.2,6.2,1.3,8.7,3.6c1.5,1.4,1.5,2.8,0.3,4.5c-1.4,2-3.5,2.7-5.6,3.6c-10.4,4.2-21.1,7.3-31.9,10.5c-10,2.9-20,5.7-30,8.5c-0.7,0.2-1,0.5-1.1,1.3c-0.7,7.3-1.4,14.6-2.1,22c-0.3,3.3-0.5,6.5-0.7,9.8C103.6,106.3,103.4,109.1,103.2,112.1z M92.1,132.9c-0.2,0-0.3-0.1-0.5-0.2c-0.7,0.5-1.3,0.9-2,1.3c-5.8,4.1-11.4,8.6-16.7,13.5c-8.8,8.2-17.1,16.8-22.9,27.4c-4.5,8.2-7,16.8-5.9,26.3c0.9,7.6,5.1,10.5,12,11c7.1,0.5,13.1-2.4,18.5-6.6c7.4-5.7,13.8-12.5,20-19.4c0.5-0.6,0.6-1.2,0.4-1.8c-0.7-3.5-1.2-7-1.6-10.5c-0.8-7-1.1-14-1.4-21C91.9,146.2,92.1,139.5,92.1,132.9z M135.4,112.1c-0.4,0-0.7,0-0.9,0c-10.9,2.6-21,7.1-30.4,13.1c-0.7,0.4-1,0.9-0.9,1.7c0.1,3.5,0.1,7,0.2,10.5c0.2,5.9,0.3,11.7,0.7,17.6c0.2,4.7,0.7,9.3,1,14c0.1,1.2,0.3,2.4,0.5,3.9C119.3,154.3,128.9,134,135.4,112.1z"></path></g></g></svg>
           日本語
         </label>
       </div>
     </div>
     <div className="mt-4 text-center">
       <LoaderButton
         type="submit"
         text="button_save"
         onClick={submitHandler}
       />
     </div>
   </div>
  );
};

export default Settings;
